.Container {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.TopRow,
.BottomRow {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  gap: 1rem;
}

@media (max-width: 1000px) {
  .Container {
    font-size: 1.2em;
  }

  .BottomRow {
    flex-direction: column;
  }
  .ExamplesPanel {
    order: 2;
  }
  .InstallationPanel {
    order: 1;
  }
}

@media (max-width: 500px) {
  .ExamplesList {
    font-size: 1.2em;
  }
}

.SubHeader {
  margin: 0 0 0.5rem;
  font-size: 1.2em;
}

.HeaderLink {
  text-decoration: none;
  background-color: var(--color-logo-background);
  border-radius: 0.5em;
  padding: 0;
  color: inherit;
}

.Code {
  display: inline-block;
  background-color: var(--color-background-code);
  font-family: monospace;
}

.ExamplesPanel,
.InstallationPanel {
  background-color: var(--color-background-code);
  border-radius: 0.5em;
  padding: 1em;
}

.ExamplesList {
  margin: 0;
  padding: 0;
  list-style: none;
}

.ExamplesListItem {
  display: flex;
  flex-direction: row;
  align-items: stretch;
  line-height: 1.75em;
  min-height: 1.75em;
}
.ListItemNumber {
  width: 3ch;
  text-align: right;
  display: inline-block;
  color: var(--token-comment-color);
  font-family: monospace;
  display: inline-block;
  padding-right: 1ch;
  margin-right: 1ch;
  border-right: 1px solid var(--color-panel-background);
}

.ExampleLink:hover {
  text-decoration: none;
}

.HeaderLogo {
  width: 12rem;
  height: 12rem;
}

.HeaderRow {
  display: inline-flex;
  flex-direction: row;
  justify-content: center;
  gap: 0.5rem;
  padding: 0.5em;
  padding-right: 1rem;

  border-radius: 1em;
  background-color: var(--color-logo-background);
}

.HeaderTexts {
  font-family: sans-serif;

  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-top: -0.75em;
}
.HeaderText {
  font-size: 3.25em;
  line-height: 1em;
  color: #fff;
}

.HeaderTagLine {
  font-size: 1.2em;
  text-align: center;
  margin: 0 0 0.5rem;
}

@media (min-width: 301px) and (max-width: 325px) {
  .HeaderText {
    font-size: 2.5em;
  }
  .HeaderTagLine {
    font-size: 1em;
  }
  .HeaderLogo {
    width: 10em;
    height: 10em;
  }
}
@media (max-width: 300px) {
  .HeaderText {
    font-size: 2em;
  }
  .HeaderTagLine {
    font-size: 0.8em;
  }
  .HeaderLogo {
    width: 8em;
    height: 8em;
  }
}
